<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body {margin: 0;}
body * {box-sizing: border-box;}
#app {font-family: Arial, sans-serif, "MicrosoftYaHei";-webkit-font-smoothing: antialiased;-moz-osx-font-smoothing: grayscale;color: #333;}
a {text-decoration: none;cursor: pointer;}
ul,li {margin: 0; padding: 0; list-style: none;}
.d-flex {display: flex;}
.d-shrink {flex-shrink: 0;}
.d-grow {flex-basis: 100%;flex-grow: 1;min-width: 0;}
.pointer {cursor: pointer;}
.overflow {overflow: hidden;}
.table {display: table;width: 100%;height: 100%;}
.ellipsis {text-overflow: ellipsis;white-space: nowrap;overflow: hidden;}
.ellipsis2 {display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;}
.clearfix:after{content: '';display: block; clear:both; }
.fl{float: left;}
.fr{float: right;}
.el-header,.el-main,.el-footer{padding: 0;}
.box-shadow{box-shadow: 0px 0px 9px 0px rgba(125, 125, 125, 0.22);border-radius: 20px 20px 0px 0px;overflow: hidden;}
.hidden{display: none !important;}

.shadowbox{position: relative;}
.shadowbox::after{position: absolute;display: block;content: '';display: block;width: 100%;height: 10px;background: #fff;bottom: -10px; }


@media (min-width: 768px) {
  body{background:#efefef;}
}
@media (max-width: 767px) {
  #app {max-width: 768px;margin: 0 auto;}
}
</style>
<style>
/* 激活表单 */
.activation{margin-top: 5px;padding-bottom: 15px;}
.activation .mainbox{padding: 20px 15px 18px 15px;}
.activation .mainbox .el-form-item{margin-bottom: 7px;}
.activation .mainbox .el-input__inner{border-radius: 20px;height: 45px;background: #efefef;font-size: 16px;text-align: center;border: none; }
.activation .mainbox .el-button--primary{font-size: 16px;color: #fff;line-height: 19px;width: 100%;border: none; text-align: center; background-image: linear-gradient(-90deg,rgba(255, 224, 77, 0.34) 0%, rgba(255, 161, 77, 0.34) 50%, rgba(255, 94, 77, 0.34) 100%),	linear-gradient(#ff7449, #ff7449);}
.activation .mainbox .el-button--primary.default{cursor: default;opacity: 0.6;}


@media (min-width: 768px) {
  .activation .codebox{width: calc(80% - 20px);float: left;}
  .activation .btnbox{width: 20%;float: right;}
  .activation .mainbox .el-input__inner{text-align: left;}
}
@media (max-width:440px) {
  .activation .codebox input::placeholder {font-size: 14px;}
}
@media (max-width:390px) {
  .activation .codebox input::placeholder {font-size: 12px;}
}


/* 分页 */
.pagebox{margin-top: 25px;}
.pagebox .van-pagination{justify-content: space-between;}
.pagebox .van-pagination__page-desc{display: none;}
.pagebox .van-pagination__item{width: 125px;height: 35px;flex: inherit;background: #ffff;color: #19d597;font-size: 14px;border-radius: 17px;border: solid 1px #19d597;}
.pagebox .van-pagination__item--disabled,.pagebox .van-pagination__item--disabled:active{opacity: 0.3;}
.pagebox .van-pagination__item:active{background-color: #19d597;color: #fff;}

/* 修改 dialog 弹框 样式 */
.van-dialog .van-dialog__message{font-size: 16px;}
.van-dialog [class*=van-hairline]::after{border-color: rgba(0, 0, 0, 0.3);}
</style>



// WEBPACK FOOTER //
// src/App.vue